<template>
  <div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-3">
            <li>
              <router-link to="/chart_of_accounts" class="">
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
              </router-link>
            </li>
            <li>
              <h3>{{ $t("accounting.label.editglaccount") }}</h3>
            </li>
          </ul>
        </div>
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("accounting.label.accounttype")
                }}</small>
                <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('accounting.label.accounttype')"
              >
                <v-select
                  label="value"
                  v-model="accountType"
                  @input="onAccountChange"
                  :options="TemplateData.accountTypeOptions"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :reduce="(obj) => obj.id"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="w-full mb-2"
                >
                  <template v-slot:option="option">{{ option.value }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("accounting.label.parent")
                }}</small>
                <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('accounting.label.parent')"
              >
                <v-select
                  label="name"
                  v-model="parent"
                  :options="parentOptions"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :reduce="(obj) => obj.id"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="w-full mb-2"
                >
                  <template v-slot:option="option">{{ option.name }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="gl code"
              >
                <vs-input
                  :label="$t('accounting.label.glcode')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="glCode"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="account name"
              >
                <vs-input
                  :label="$t('accounting.label.accountname')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="accountName"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>

            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("accounting.label.accountusage")
                }}</small>
                <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('accounting.label.accountusage')"
              >
                <v-select
                  label="value"
                  v-model="accountUsage"
                  :options="TemplateData.usageOptions"
                  :reduce="(obj) => obj.id"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  class="w-full mb-2"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("accounting.label.tag")
                }}</small>
                <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('accounting.label.tag')"
              >
                <v-select
                  label="name"
                  v-model="tag"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :options="tagOptions"
                  :reduce="(obj) => obj.id"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="w-full mb-2"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('accounting.label.description')"
              >
              <vs-input
                :label="$t('accounting.label.description')"
                class="w-full mb-2 font-semibold"
                v-model="description"
              />
              <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-checkbox
                class="mt-5 mb-5 font-semibold"
                v-model="manualEntriesAllowed"
                >{{ $t("accounting.label.manualentriesallowed") }}</vs-checkbox
              >
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="$router.push('/chart_of_accounts')"
            >{{ $t("accounting.label.cancel") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="haldleSubmit"
            >{{ $t("accounting.label.update") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  data() {
    return {
      accountType: "",
      parent: "",
      glCode: "",
      accountName: "",
      accountUsage: "",
      tag: "",
      description: "",
      manualEntriesAllowed: "true",
      warningPopup: false,
      warningText: "",
      errorMessage: "",
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    ...mapState({
      TemplateData: (state) => state.accounting.accountTemplate,
      accountViewData: (state) => state.accounting.accountTemplateById,
    }),
    parentOptions() {
      switch (this.accountType) {
        case 1:
          return this.TemplateData.assetHeaderAccountOptions;
        case 2:
          return this.TemplateData.liabilityHeaderAccountOptions;
        case 3:
          return this.TemplateData.equityHeaderAccountOptions;
        case 4:
          return this.TemplateData.incomeHeaderAccountOptions;
        case 5:
          return this.TemplateData.expenseHeaderAccountOptions;
        default:
          return [];
      }
    },
    tagOptions() {
      switch (this.accountType) {
        case 1:
          return this.TemplateData.allowedAssetsTagOptions;
        case 2:
          return this.TemplateData.allowedLiabilitiesTagOptions;
        case 3:
          return this.TemplateData.allowedEquityTagOptions;
        case 4:
          return this.TemplateData.allowedIncomeTagOptions;
        case 5:
          return this.TemplateData.allowedExpensesTagOptions;
        default:
          return [];
      }
    },
  },
  methods: {
    async getTemplateData() {
      try {
        await this.$store.dispatch("accounting/accountTemplateDataAction");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getTemplateDataById() {
      try {
        await this.$store.dispatch(
          "accounting/accountTemplateDataByIdAction",
          this.id
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.accountType = this.accountViewData.type.id;
      this.parent = this.accountViewData.parentId;
      this.glCode = this.accountViewData.glCode;
      this.accountName = this.accountViewData.name;
      this.accountUsage = this.accountViewData.usage.id;
      this.tag = this.accountViewData.tagId;
      this.description = this.accountViewData.description;
      this.manualEntriesAllowed = this.accountViewData.manualEntriesAllowed;
    },
    async haldleSubmit() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      const payload = {
        id: this.id,
        data: {
          description: this.description,
          glCode: this.glCode,
          manualEntriesAllowed: this.manualEntriesAllowed,
          name: this.accountName,
          tagId: this.tag,
          type: this.accountType,
          usage: this.accountUsage,
        },
      };
      if (this.parent) {
        payload.data.parentId = this.parent;
      }
      try {
        await this.$store.dispatch("accounting/updateGLAccountAction", payload);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "GL Account Edited Successfully!",
          type: "success",
        });
        this.resetForm();
        this.$router.push("/chart_of_accounts");
      } catch (error) {
        const errorMessage = String(error.httpStatusCode).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    resetForm() {
      this.event = null;
    },
    onAccountChange() {
      this.parent = "";
      this.tag = "";
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getTemplateData();
    this.getTemplateDataById();
  },
};
</script>
